module.exports = __webpack_public_path__ + "static/fonts/TrebuchetMS-Bold.e34328a.woff";